import {styled} from '@mui/material/styles'
import Checkbox from '@mui/material/Checkbox'

/**
 * FilterCheckbox - Custom styled checkbox for filter components
 *
 * Provides consistent styling across all filter checkboxes with custom colors
 * and hover effects matching the application's design system.
 */
export const FilterCheckbox = styled(Checkbox)(({theme}) => ({
  color: theme.palette.hpPrimaryDark,
  '&.Mui-checked': {
    color: theme.palette.primary.main
  },
  '&:hover': {
    backgroundColor: theme.palette.hpPrimaryLightest
  }
}))
